const revenueData = [
  {
    country: "USA",
    name: "0K",
    value: 100,
    color1: "#C1BDBB",
    color2: "#848A9C",
  },
  {
    country: "Korea",
    name: "0K",
    value: 80,
    color1: "#CBDCDE",
    color2: "#00D4F1",
  },
  {
    country: "Australia",
    name: "0K",
    value: 60,
    color1: "#19B6E8",
    color2: "#0D5EFD",
  },
  {
    country: "United Kingdom",
    name: "0K",
    value: 40,
    color1: "#ED4B99",
    color2: "#E2398A",
  },
  {
    country: "Turkey",
    name: "0K",
    value: 20,
    color1: "#FCDE90",
    color2: "#FCB500",
  },
];

// convertion 1000 to 1k i.e
function formatToK(value) {
  if (typeof value !== "number") return null;
  if (value < 1000) return value.toString();
  return (value / 1000).toFixed(1) + "k";
}

export function getCountriesRevnueData(countriesRevenue) {
  if (!countriesRevenue && !Array.isArray(countriesRevenue)) {
    return revenueData;
  }

  return countriesRevenue
    ?.filter((state) => state.name !== "")
    .map((state, idx) => {
      return {
        ...revenueData[idx],
        name: formatToK(state?.total_amount),
        country: state?.name,
      };
    });
}
